import { render, staticRenderFns } from "./AppParagraph.vue?vue&type=template&id=ed4d8802&scoped=true&"
import script from "./AppParagraph.vue?vue&type=script&lang=js&"
export * from "./AppParagraph.vue?vue&type=script&lang=js&"
import style0 from "./AppParagraph.vue?vue&type=style&index=0&id=ed4d8802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d8802",
  null
  
)

export default component.exports